import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { ElementConditionEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class ElementConditionSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    elementConditionCreated$() {
        return this.socketService.receiveMessageObserver(ElementConditionEvents.ELEMENT_CONDITION_CREATED);
    }

    elementConditionUpdated$() {
        return this.socketService.receiveMessageObserver(ElementConditionEvents.ELEMENT_CONDITION_UPDATED);
    }

    elementConditionDeleted$() {
        return this.socketService.receiveMessageObserver(ElementConditionEvents.ELEMENT_CONDITION_DELETED);
    }
}
